<template>
  <section class="mt-16">
    <IntroVideo />
    <ProduceRoadbooks />
    <EventsBanner :images="eventsBannerImages" />
  </section>
  <section
    class="m-auto bg-black pt-6 px-2 md:px-10 pb-5 shadow-black shadow-xl max-w-[1400px]"
  >
    <div
      class="my-8 text-lg flex flex-col border-white border-t-2 border-b-2 divide-y-2 divide-white py-4"
    >
      <div>
        <p class="text-white pb-4 font-arial font-semibold text-[18px]">
          Rally Navigator Streamlines the Process of Creating Rally Navigation
          Roadbooks Using the Power of Digital Mapping and GPS. Design Your
          Route, Add Waypoint Details and Produce FIA Specification Rally
          Roadbook PDF + Matching GPX File for Cross Country and Road & Stage
          Rally Events. It is a complete roadbook editor and road book maker for
          desktop, with a companion roadbook reader app for Android and iOS.
        </p>
        <h2 class="text-[#FF0000] font-russo text-[24px] md:text-[36px] py-4">
          CREATE. SHARE. RALLY.
        </h2>
        <!-- The heading above brings 16px (py-4), so a smaller top pad here and a
             bottom pad keep the gaps above and below the buttons even. -->
        <RoadbookCtas class="!pt-4 pb-8" />
      </div>
      <div class="flex flex-col md:flex-row gap-8 p-8 w-full justify-between">
        <router-link to="how-to-create-a-cross-country">
          <picture class="contents">
            <source
              srcset="/images/CC-Roadbook-Image-qbqkj0exbp9dd466e7ex7ryf7wdwx9qdmhdcijtm1k.webp"
              type="image/webp"
            />
            <img
              decoding="async"
              src="/images/CC-Roadbook-Image-qbqkj0exbp9dd466e7ex7ryf7wdwx9qdmhdcijtm1k.png"
              title="CC Roadbook Image"
              alt="CC Roadbook Image"
              loading="lazy"
              width="450"
              height="700"
              class="m-auto"
            />
          </picture>
        </router-link>
        <router-link to="how-to-create-a-road-rally">
          <picture class="contents">
            <source
              srcset="/images/Road-Rally-Roadbook-qbqkj0exbp9dd466e7ex7ryf7wdwx9qdmhdcijtm1k.webp"
              type="image/webp"
            />
            <img
              decoding="async"
              src="/images/Road-Rally-Roadbook-qbqkj0exbp9dd466e7ex7ryf7wdwx9qdmhdcijtm1k.png"
              title="Road Rally Roadbook"
              alt="Road Rally Roadbook"
              loading="lazy"
              width="450"
              height="700"
              class="m-auto"
            />
          </picture>
        </router-link>
      </div>
      <div>
        <ul class="pt-4 font-arial text-[17px] font-bold text-[#A9A9A9]">
          <li class="md:py-1">MapBox 3D Terrain Imagery</li>
          <li class="md:py-1">Runs - Saves - Prints PDF on Local Computer</li>
          <li class="md:py-1">Share via Dropbox, iCloud, OneDrive</li>
          <li class="md:py-1">
            Adjustable Waypoint & Validation Radius Details Show on Map
          </li>
          <li class="md:py-1">On Screen Roadbook Auto Highlighting</li>
          <li class="md:py-1">FIA/Dakar Navigation Icons in SVG</li>
        </ul>
        <picture class="contents">
          <source
            srcset="/images/toolbar3adad-1024x576.webp"
            type="image/webp"
          />
          <img
            decoding="async"
            loading="lazy"
            width="1024"
            height="576"
            src="/images/toolbar3adad-1024x576.png"
            class="m-auto py-8"
            alt="Rally Navigator roadbook creation software running on desktop"
          />
        </picture>
      </div>
      <div>
        <router-link to="/timing-scoring">
          <h2
            class="font-russo text-[24px] md:text-[28px] text-[#FF0000] py-4 hover:underline uppercase"
          >
            RALLY NAVIGATOR INTEGRATES WITH LEADING RALLY TRACKING SYSTEMS
          </h2>
        </router-link>
        <PartnersStandard :partner-link="false" />
        <p
          class="text-white font-arial text-[16px] md:text-[20px] font-semibold"
        >
          Print PDF Roadbooks & Download Matching GPX File With Complete Stage
          Data - Loads Directly to Rally Tracking & Scoring System - Reduce
          Human Error & Save Time
        </p>
      </div>
    </div>
    <div>
      <router-link to="/mobile-roadbook-reader">
        <h2
          class="font-russo text-[24px] md:text-[28px] text-[#FF0000] pb-4 hover:underline"
        >
          DIGITAL ROADBOOK READER APP FOR ANDROID AND IOS
        </h2>
        <picture class="contents">
          <source srcset="/images/New-Reader-Icon.webp" type="image/webp" />
          <img
          decoding="async"
          loading="lazy"
          width="250"
          height="250"
          src="/images/New-Reader-Icon.png"
          class="m-auto"
          alt="Rally Roadbook Reader mobile app icon"
          />
        </picture>
      </router-link>
    </div>
  </section>
  <FaqSection />
  <section class="my-8 max-w-[1400px] m-auto">
    <PartnersSmall />
    <RallyLogoDownload link-text="Download Rally Navigator" />
  </section>
</template>

<script>
import PartnersStandard from './PartnersStandard.vue';
import PartnersSmall from './PartnersSmall.vue';
import RallyLogoDownload from './RallyLogoDownload.vue';
import IntroVideo from './IntroVideo.vue';
import ProduceRoadbooks from './ProduceRoadbooks.vue';
import EventsBanner from './EventsBanner.vue';
import FaqSection from './FaqSection.vue';
import RoadbookCtas from './RoadbookCtas.vue';

export default {
  name: 'HomePage',
  components: {
    RoadbookCtas,
    IntroVideo,
    PartnersStandard,
    PartnersSmall,
    RallyLogoDownload,
    ProduceRoadbooks,
    EventsBanner,
    FaqSection,
  },
  data() {
    return {
      eventsBannerImages: [],
    };
  },
  mounted() {
    fetch('/BannerImagesLists/RNBannerImageList.json')
      .then((response) => response.json())
      .then((data) => {
        this.eventsBannerImages = data.sort(() => Math.random() - 0.5);
      });
  },
};
</script>

<style scoped></style>
